import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../Component/SIdebar/Sidebar';

const Layout = () => {
    return (
        <div className="max-w-[90rem] mx-auto px-4 sm:px-6 md:px-8 ">
        <Sidebar></Sidebar>
        <div className="lg:pl-[14rem]  mt-[5.8125rem]">
            <Outlet></Outlet>
        </div>
    </div>
    );
};

export default Layout;